export const NewsletterStatus = {
  ACTIVE: "active",
  INACTIVE: "inactive",
  // DO_NOT_CONTACT: "do_not_contact",
};
